import { updateCurrencyAction, ValuesActionType } from './valueActionTypes';
import { Currency } from '../../utils/constants';

export const updateCurrency = (currency: Currency): updateCurrencyAction => ({
  type: ValuesActionType.updateCurrency,
  payload: {
    currency
  }
});
